import { type QueryClient } from '@tanstack/react-query';

import { type Clip } from '@air/api/types';

import { isClipWithoutWorkspaceIdKey } from '~/swr-hooks/useGetClipWithNoWorkspaceId';

export const getMostRecentlyUpdatedCachedClipWithTranscriptVtt = ({
  queryClient,
  clipId,
}: {
  queryClient: QueryClient;
  clipId: Clip['id'];
}): Clip | undefined => {
  const cachedClipsWithTranscriptVtt = queryClient
    .getQueriesData<Clip>({
      predicate: (query) => isClipWithoutWorkspaceIdKey(query.queryKey) && query.queryKey[1].clipId === clipId,
    })
    .map(([, clip]) => clip)
    .filter((clip): clip is Clip => !!clip?.assets?.transcriptVtt);

  return cachedClipsWithTranscriptVtt.reduce<Clip | undefined>((mostRecentlyUpdatedClip, clip) => {
    if (!mostRecentlyUpdatedClip) {
      return clip;
    }

    return new Date(clip.updatedAt).getTime() > new Date(mostRecentlyUpdatedClip.updatedAt).getTime()
      ? clip
      : mostRecentlyUpdatedClip;
  }, undefined);
};
